import type { ExternalEventTrackingClient } from './types';

let currentZettaClient: ExternalEventTrackingClient | null = null;

/**
 * 앱에서 생성한 ZettaClient를 libs 공용 logger 경로에 주입합니다.
 *
 * libs는 PostHog SDK 인스턴스를 직접 만들지 않고, 앱 composite root에서
 * 초기화한 클라이언트를 통해서만 tracking을 전송합니다.
 */
export function setZettaClient(client: ExternalEventTrackingClient): void {
  currentZettaClient = client;
}

export const zettaClient: ExternalEventTrackingClient = {
  identify: (userId, eventProperties) => {
    currentZettaClient?.identify(userId, eventProperties);
  },
  resetIdentity: () => {
    currentZettaClient?.resetIdentity();
  },
  setUserProperties: eventProperties => {
    currentZettaClient?.setUserProperties(eventProperties);
  },
  track: (eventName, eventProperties) => {
    currentZettaClient?.track(eventName, eventProperties);
  },
};
